import { useState, useEffect, useCallback } from 'react';
import { getInstanceState } from './identity_services';

/**
 * Loads the aggregated IDEM instance state (data sources, Brain structure,
 * engines) parsed server-side from `self/STATE.md`. Mirrors the shape of
 * `useIdentityFiles` so both hooks compose the same way in the module.
 */
export const useInstanceState = () => {
  const [state, setState] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const data = await getInstanceState();
      setState(data);
    } catch (err) {
      console.error('Error loading identity instance state:', err);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { state, isLoading, error, refresh: load };
};
